'use client';

import { useMemo, useState } from 'react';
import Link from 'next/link';
import { Search } from 'lucide-react';
import { Icon } from '@/components/ui/Icon';
import { searchArticles } from '@/lib/help/search';
import { helpPath } from '@/lib/help/href';
import type { HelpArticle } from '@/lib/help/types';

export default function HelpSearch({ articles }: { articles: HelpArticle[] }) {
  const [query, setQuery] = useState('');

  const results = useMemo(
    () => searchArticles(query, articles, 6),
    [query, articles],
  );

  const show = query.trim().length > 1 && results.length > 0;

  return (
    <div className="help-search">
      <div className="help-search-row">
        <Icon icon={Search} size={18} className="help-search-icon" />
        <input
          type="search"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder='Try "send a quote" or "add a client"'
          className="help-search-input"
          aria-label="Search help articles"
        />
      </div>
      {show && (
        <ul className="help-search-results">
          {results.map((a) => (
            <li key={`${a.category}/${a.slug}`}>
              <Link href={helpPath(`/${a.category}/${a.slug}`)} className="help-search-result">
                <div className="help-search-result-title">{a.title}</div>
                <div className="help-search-result-summary">{a.summary}</div>
              </Link>
            </li>
          ))}
        </ul>
      )}
      {query.trim().length > 1 && results.length === 0 && (
        <div className="help-search-empty">
          No matches. Try a different phrase, or ask Mucka inside the app.
        </div>
      )}
    </div>
  );
}
